import { ValidationInputType } from "@cak-legacy/generation-core";
import { FileAbstractValidation } from "./FileAbstractValidation";
import { CustomErrorMessage } from "./ValidationHelper";
import { translate } from "../Locales/translator";

export class HasFileExtensionValidation extends FileAbstractValidation {
  key = "hasFileExtension";
  constructor(
    private readonly extensions: string[],
    customErrorMessage?: CustomErrorMessage,
    private readonly customFileErrorMessage?: CustomErrorMessage
  ) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    const invalidFiles = this.getFiles(value).filter((file) => !this.isValidFile(file));
    return invalidFiles.length === 0;
  };

  isValidFile = (file: File) => {
    const lowerCaseExtensions = this.extensions.map((extension) => extension.toLowerCase());

    const extensionRegex = /(?:\.([^.]+))?$/;
    const fileExtensionMatches = extensionRegex.exec(file.name.toLowerCase());
    const fileExtension =
      fileExtensionMatches && fileExtensionMatches?.length > 1 ? fileExtensionMatches[1] : "invalid";
    return lowerCaseExtensions.indexOf(fileExtension) >= 0;
  };

  defaultMessage = (_label: string): string =>
    translate("Generation_Form_Alleen{extensions}ZijnGeldig", { extensions: this.extensions.join(" ") });

  fileErrorMessage = (fileLabel: string): string =>
    this.customFileErrorMessage
      ? this.customFileErrorMessage(fileLabel)
      : translate("Generation_Form_{fileLabel}MoetVanHetType{extensions}Zijn", { fileLabel: fileLabel, extensions: this.extensions.join(" ") });
}
